import { render, staticRenderFns } from "./contentCourseDeleteSection.vue?vue&type=template&id=e3c080e6&"
import script from "./contentCourseDeleteSection.vue?vue&type=script&lang=js&"
export * from "./contentCourseDeleteSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports